'use client';

import { Text, TextArea } from '@instamenu/ui-system-next';
import { useMenuItemContext } from '../menu-item-context';
import { useCheckoutContext } from '@instamenu/context-checkout';

export const SpecialInstructions = () => {
  const ctx = useMenuItemContext();
  const checkout = useCheckoutContext();
  if (!ctx) return null;

  const { instructions, setInstructions } = ctx;

  if (!checkout?.restaurant.setting.storefront.enableOnlineSpecialInstructions) return null;
  return (
    <>
      <Text variant="subtitle1">Special Instructions</Text>
      <TextArea
        placeholder="Add any special requests (e.g. allergies, extra spicy, onions on the side) and we'll do our best to accommodate you."
        rows={4}
        value={instructions}
        onChange={(e) => setInstructions(e.target.value)}
        css={{ marginTop: 4 }}
      />
    </>
  );
};
